<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="formData" :rules="validatorRules" slot="detail" :colon="false">
          <a-divider class="aDividerBlue" orientation="left">{{ $t('工单信息') }}</a-divider>
          <detail-list :col="3">
            <detail-list-item :term="$t('工单编号')">{{ formData.model.ticketsNum }}</detail-list-item>
            <detail-list-item :term="$t('工单类型')">{{ formData.model.ticketsType == 2 ? $t('故障报修') : $t('水厂报修') }}</detail-list-item>
            <detail-list-item :term="$t('工单联系人')">{{ formData.model.ticketsContact }}</detail-list-item>
          </detail-list>
          <detail-list :col="3">
            <detail-list-item :term="$t('紧急程度')">
              <a-tag :color="getTagColor(formData.model.ticketsEmergency)">
                {{ setJJ(formData.model.ticketsEmergency) }}
              </a-tag>
            </detail-list-item>
            <detail-list-item v-if="formData.model.ticketsType == 2" :term="$t('预约时间')">{{ formData.model.ticketsDeadline }}</detail-list-item>
            <detail-list-item :term="$t('联系电话')">{{ formData.model.ticketsContactPhone }}</detail-list-item>
            <!-- <detail-list-item term="地理信息">{{formData.model.ticketsLocation}}</detail-list-item> -->
          </detail-list>
          <detail-list :col="3">
            <detail-list-item
              :term="$t('换表原因')"
              v-if="formData.model.ticketsChangeMeter?.changingMeterReason"
              :itemCol="1"
            >
              {{ changingMeterReason }}
            </detail-list-item>
            <!-- <detail-list-item term="截止时间">{{model.ticketsDeadline}}</detail-list-item> -->
          </detail-list>

          <!-- 保修- 系统用户 -->
          <template v-if="formData.model.repairCreateOrderUserType == 1">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('用户信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('用户编号')">{{
                formData.model.user && formData.model.user.userId
              }}</detail-list-item>
              <detail-list-item :term="$t('用户姓名')">{{ formData.userInfo.userName }}</detail-list-item>
              <detail-list-item :term="$t('手机号码')">{{ formData.userInfo.userPhone }}</detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('开户时间')">{{ formData.userInfo.userCreateTime }}</detail-list-item>
              <detail-list-item :term="$t('用水性质')">{{ formData.userInfo.wtName }}</detail-list-item>
              <detail-list-item :term="$t('用水状态')">{{
                formData.userInfo.userState == 0 ? $t('未开始计费') : formData.userInfo.userState == 1 ? $t('已开始计费') : ''
              }}</detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('区域信息')" :itemCol="1">{{ formData.userInfo.userAreaName }}</detail-list-item>
              <detail-list-item :term="$t('用户地址')" :itemCol="1">{{ formData.userInfo.userAddr }}</detail-list-item>
              <!-- <detail-list-item term="用户地址" :itemCol="2">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
            </detail-list>

            <!-- <detail-list :col="3"> -->
            <!-- <detail-list-item term="开户时间">{{formData.oldMeter.userCreateTime}}</detail-list-item> -->
            <!-- <detail-list-item term="用户地址">{{formData.oldMeter.userAddr}}</detail-list-item> -->
            <!-- <detail-list-item :itemCol="1" term="用户地址">{{formData.oldMeter.userAreaName && formData.oldMeter.userAreaName.slice(formData.oldMeter.userAreaName.indexOf('-')+1,formData.oldMeter.userAreaName.length)+'-'+formData.oldMeter.userAddr}}</detail-list-item> -->
            <!-- </detail-list> -->

            <a-divider class="aDividerBlue" orientation="left">{{ $t('旧表信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('旧表编号')">{{ formData.oldMeter.meterId }}</detail-list-item>
              <!-- <detail-list-item term="用水性质">{{formData.oldMeter.wtName}}</detail-list-item> -->
              <detail-list-item :term="$t('水表厂家')">{{
                formData.oldMeter.mtName ? formData.oldMeter.mtName : formData.oldMeter.meterTypeName
              }}</detail-list-item>
              <detail-list-item :term="$t('口径')">
                {{ formData.oldMeter&&formData.oldMeter.mtCaliber ? 'DN' + formData.oldMeter.mtCaliber : '' }}
              </detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('表计费起始读数')">{{ formData.oldMeter.oldMeterStartNum }}</detail-list-item>
              <detail-list-item :term="$t('末次上报结算流量(m³)')">{{ formData.oldMeter.oldUserCalNum }}</detail-list-item>
              <detail-list-item :term="$t('末次上报结算余额(元)')">{{ formData.oldMeter.userAccountNum }}</detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('末次上报日期')">{{ formData.oldMeter.meterUpTime }}</detail-list-item>
            </detail-list>
          </template>
          <!-- 保修- 非系统用户 -->
          <template v-if="formData.model.repairCreateOrderUserType == 0">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('报修信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('报修人名称')">{{ formData.model.repairName }} </detail-list-item>
              <detail-list-item :term="$t('报修人电话')">{{ formData.model.repairPhone }}</detail-list-item>
              <detail-list-item v-if="formData.model.ticketsType == 2" :term="$t('报修地址')">{{ formData.model.repairAddress }}</detail-list-item>
              <detail-list-item v-if="formData.model.ticketsType == 11" :term="$t('设备信息')">{{ formData.model.repairAddress }}</detail-list-item>
            </detail-list>
          </template>
          <!-- 报修- 报修信息-->
          <template>
            <a-divider class="aDividerBlue" orientation="left">{{ $t('报修信息') }}</a-divider>
            <detail-list :col="3">
              <detail-list-item :itemCol="1" :term="$t('报修描述')">{{ formData.model.repairDescription }} </detail-list-item>
            </detail-list>
            <detail-list>
              <detail-list-item :term="$t('报修图片')" style="display: flex; width: 100%">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  style="display: block"
                  disabled
                  :isMultiple="true"
                  v-model="formData.model.repairPicture"
                ></j-image-upload>
              </detail-list-item>
            </detail-list>
          </template>
          <!-- 报修- 处理信息 当单据存在处理图片时-->
          <template v-if="formData.model.resolvedPictureFront">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('处理信息') }}</a-divider>

            <detail-list :col="3">
              <detail-list-item :term="$t('处理人账号')">{{ formData.model.handleUserName }}</detail-list-item>
              <detail-list-item :term="$t('处理人名称')">{{ formData.model.handleUserRealName }}</detail-list-item>
              <detail-list-item :term="$t('处理人电话')">{{ formData.model.handleUserPhone }}</detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('是否换表')" v-if="formData.model.repairCreateOrderUserType == 1">{{
                formData.model.ifNeedChangeMeter == 1 ? $t('换表') : $t('不换表')
              }}</detail-list-item>
            </detail-list>
          </template>

          <!-- 如果不换表 且 存在 处理前照片 -->
          <template
            v-if="
              formData.model.ifNeedChangeMeter == 0 &&
              (formData.model.resolvedPictureFront || formData.model.resolvedPictureOpposite)
            "
          >
            <detail-list :col="2">
              <detail-list-item :term="$t('处理前照片')" style="display: flex">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  disabled
                  :isMultiple="true"
                  v-model="formData.model.resolvedPictureFront"
                ></j-image-upload>
              </detail-list-item>
              <detail-list-item :term="$t('处理后照片')" style="display: flex">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  disabled
                  :isMultiple="true"
                  v-model="formData.model.resolvedPictureOpposite"
                ></j-image-upload>
              </detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('处理描述')" :itemCol="1">{{
                formData.model.handleUserDescription
              }}</detail-list-item>
            </detail-list>
          </template>

          <!-- 报修  系统用户 换表  -->
          <template v-if="formData.model.repairCreateOrderUserType == 1 && formData.model.ifNeedChangeMeter == 1">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('新表具信息') }}</a-divider>

            <detail-list :col="3">
              <detail-list-item :term="$t('新表编号')">{{ formData.newMeter.newMeterId }}</detail-list-item>
              <detail-list-item :term="$t('水表厂商')">{{ formData.newMeter.newMtName }} </detail-list-item>
              <detail-list-item :term="$t('口径')">
                {{ formData.newMeter && formData.newMeter.newMtCaliber ? 'DN' + formData.newMeter.newMtCaliber : '' }}
              </detail-list-item>
            </detail-list>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('换表操作') }}</a-divider>
            <detail-list>
              <detail-list :col="2">
                <detail-list-item
                  v-if="formData.model.ticketsChangeMeter && formData.model.ticketsChangeMeter.meterOldMachineSumFlow"
                  :term="$t('旧表机械读数(m³)')"
                  :col="2"
                >
                  {{
                    formData.model.ticketsChangeMeter && formData.model.ticketsChangeMeter.meterOldMachineSumFlow
                  }}</detail-list-item
                >
                <detail-list-item :term="$t('新表开始计费读数(m³)')">{{ formData.newMeter.meterStartNum }} </detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('处理前照片')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    disabled
                    :isMultiple="true"
                    v-model="formData.model.resolvedPictureFront"
                  ></j-image-upload>
                </detail-list-item>
                <detail-list-item :term="$t('处理后照片')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    disabled
                    :isMultiple="true"
                    v-model="formData.model.resolvedPictureOpposite"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('是否旧表机械读数结算')">
                  {{
                    formData.model.ticketsChangeMeter?.whetherSettlementOldTable === null
                      ? ''
                      : formData.model.ticketsChangeMeter?.whetherSettlementOldTable === 1
                      ? $t('是')
                      : $t('否')
                  }}
                </detail-list-item>
                <detail-list-item :term="$t('是否收费')">{{ $t(formData.model.payOrNot) }} </detail-list-item>
              </detail-list>

              <detail-list :col="1">
                <detail-list-item :term="$t('电子签名')" style="display: flex">
                  <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false" v-if="formData.model.ticketsChangeMeter&&formData.model.ticketsChangeMeter.electronicSignature">
                    <img style="width: 180px; height: 80px" :src="formData.model.ticketsChangeMeter&&formData.model.ticketsChangeMeter.electronicSignature" />
                    <div class="mask-sig" :class="{ 'mask-show': isShow }">
                      <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                      <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                    </div>
                  </div>
                  <i v-else>{{ $t('暂无签名') }}</i>
                </detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('剩余金额(元)')">
                  {{
                    formData.model.ticketsChangeMeter &&
                    formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange
                  }}
                </detail-list-item>
                <detail-list-item :term="$t('收费金额(元)')" v-if="formData.model.payOrNot == '收费'">
                  {{
                    formData.model.ticketsChangeMeter &&
                    formData.model.ticketsChangeMeter.feeAmount
                  }}
                </detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('支付凭证')" style="display: flex" v-if="formData.model.payOrNot == '收费'">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    disabled
                    v-model="formData.model.infoPicture"
                  ></j-image-upload>
                </detail-list-item>
                <detail-list-item :term="$t('协议书照片')" style="display: flex" v-if="formData.model.payOrNot == '收费'&&formData.model.ticketsChangeMeter">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    disabled
                    v-model="formData.model.ticketsChangeMeter.protocolPicture"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('处理描述')" :itemCol="1">{{
                  formData.model.handleUserDescription
                }}</detail-list-item>
              </detail-list>
            </detail-list>
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>

    <!-- 选择新表弹窗 -->
    <SelectNewMeterModal
      :visible="selectNewMeterModalVisible"
      @update:visible="val => (selectNewMeterModalVisible = val)"
      @ok="handleMeterSelected"
    />
    <j-modal
      :title="$t('预览')"
      :width="448"
      :visible="visibleSig"
      @cancel="handleSigCancel"
      :okButtonProps="{ class: { 'jee-hidden': true } }"
    >
      <div style="width: 400px; height: 400px">
        <img :src="formData.model&&formData.model.ticketsChangeMeter&&formData.model.ticketsChangeMeter.electronicSignature" alt="" style="width: 100%; height: 100%" />
      </div>
    </j-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel1">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </j-modal>
</template>

<script>
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JInput from '@/components/jeecg/JInput'
import { PhoneNumberPattern } from '@/utils/regPattern'
import SelectNewMeterModal from './selectNewMeter.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import DetailList from '@/components/tools/DetailList'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
const DetailListItem = DetailList.Item
import {fileUrl} from'@/utils/util'
export default {
  mixins: [JeecgListMixin],
  name: 'auditModal',
  components: {
    DetailList,
    DetailListItem,
    JImageUpload,
    JUpload,
    JInput,
    SelectNewMeterModal,
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: true,
      confirmLoading: false,
      optionType: '', // 操作类型
      changingMeterReason: '', // 换表原因
      formData: {
        model: {
          ticketsEmergency: null,
          ifNeedChangeMeter: null,
        }, // 工单信息
        userInfo: {}, // 系统用户信息
        oldMeter: {
          whetherSettlementOldTable: null,
        }, // 旧表信息
        newMeter: {}, // 新表信息
      }, // 表单信息
      qrcodeImage: [
        {
          uid: '-1',
          name: '付款码',
          status: 'done',
          url: fileUrl+'/file/payment_code.png',
        }
      ],
      previewVisible: false,
      previewImage: '',
      validatorRules: {
        // fixPhone:[{ required: true, message: '请输入修理人员电话' },{pattern: PhoneNumberPattern,message: '请输入正确的手机号码'}],
        // handleUserDescription:{ required: true,message: '请输入处理描述', trigger: 'blur' },
        // fixSolve:{ required: true,message: '请选择是否解决', trigger: 'change' },
        // fixPicture:{ required: true,message: '请选择修理图片', trigger: 'change' },
      },
      url: {
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        reject: '/jeecg-engineering/flowable/task/taskRejectByDataId',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        edit: '/jeecg-engineering/engineering/meterRepair/edit',
        useOldMachineSumFlow: '/jeecg-charge/meter/meteChangeMeterRecord/useOldMachineSumFlow', //是否以旧表读数结算
        newMeterInfo: '/jeecg-charge/meter/meterinfo/list', //新表接口
        list: '/jeecg-charge/meter/meterUserinfo/list',
        userList: '/sys/user/list',
        getMeterUserInfoByKeyId: '/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId', //换表请求
      },
      candidateUsersList: [],
      meterRepair: {},
      fileList: '',
      selectNewMeterModalVisible: false,
      isShow: false,
      visibleSig: false,
    }
  },
  computed: {
    options() {
      const t = this.$t
      return [
        {
          value: '0',
          label: t('周期性换表'),
        },
        {
          value: '1',
          label: t('故障换表'),
          children: [
            {
              value: '2',
              label: t('基表问题'),
              children: [
                {
                  value: '3',
                  label: t('计量问题'),
                },
                {
                  value: '4',
                  label: t('阀门故障'),
                },
                {
                  value: '5',
                  label: t('基表爆裂'),
                },
              ],
            },
            {
              value: '6',
              label: t('电子问题'),
              children: [
                {
                  value: '7',
                  label: t('不上传数据'),
                },
                {
                  value: '8',
                  label: t('水表无反应（黑屏，无法激活）'),
                },
              ],
            },
            {
              value: '9',
              label: t('磁干扰'),
            },
            {
              value: '10',
              label: t('缺电'),
            },
            {
              value: '11',
              label: t('其他'),
            },
          ],
        },
      ]
    },
    reasonLabelMap() {
      const map = {}
      const buildMap = (options, parentPath = []) => {
        // 显示 层级路径
        // options.forEach(item => {
        //   const currentPath = [...parentPath, item.label];
        //   map[item.value] = currentPath.join(' / ');
        //   if (item.children) buildMap(item.children, currentPath);
        // });
        // 只显示 最后一级
        options.forEach(item => {
          // 如果是叶子节点（没有 children），存储其 label
          if (!item.children || item.children.length === 0) {
            map[item.value] = item.label
          }
          // 递归处理子级
          if (item.children) {
            buildMap(item.children)
          }
        })
      }
      buildMap(this.options)
      return map
    },
  },
  watch: {
    'model.audit': {
      handler(val) {
        if (val == 1) {
          this.validatorRules.remark.required = false
        } else {
          this.validatorRules.remark.required = true
        }
      },
    },
    'model.handleUserName': {
      handler(val) {
        if (val) {
          var info = this.candidateUsersList.find(item => item.username == val)
          this.$set(this.formData.model, 'handleUserRealName', info.realname)
          this.$set(this.formData.model, 'handleUserPhone', info.telephone || info.phone)
        }
      },
    },
  },
  methods: {
    setJJ(item) {
      return filterDictTextByCache('ticketsEmergency', item)
    },
    getUserList() {
      this.candidateUsersList = []
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.candidateUsersList = res.result.records
        }
      })
    },
    init(row, type) {
      let that = this
      this.title = this.$t(type)
      this.optionType = type
      this.visible = true
      that.confirmLoading = false
      this.changingMeterReason = ''
      this.formData = {
        model: {
          id: row.id,
          ticketsType: row.ticketsType,
          ticketsId: row.id,
        }, // 工单信息
        userInfo: {}, // 系统用户信息
        oldMeter: {}, // 旧表信息
        newMeter: {}, // 新表信息
      }

      this.getUserList()
      // 获取工单数据
      getAction(this.url.queryById, { id: row.id }).then(res => {
        if (res.success) {
          that.formData.model = Object.assign({}, that.formData.model, res.result)
          that.meterRepair = res.result.wechatMeterRepair
          /*
            this.$nextTick(()=>{
              if(res.result.wechatMeterRepair.source == 1){
                var arr = JSON.parse(res.result.wechatMeterRepair.repairPicture);
                this.$set(this,'fileList',arr.join(','));
              }else{
                this.$set(this,'fileList',res.result.wechatMeterRepair.repairPicture);
              }
            })
*/
          that.formData.model = Object.assign({}, that.formData.model, {
            bzId: that.formData.model.wechatMeterRepair.id,
            // 报修人信息
            repairName: that.formData.model.wechatMeterRepair.repairName,
            repairPhone: that.formData.model.wechatMeterRepair.repairPhone,
            repairAddress: that.formData.model.wechatMeterRepair.repairAddress,
            repairTime: that.formData.model.wechatMeterRepair.repairTime,
            repairPicture: that.formData.model.repairPicture||that.formData.model.wechatMeterRepair.repairPicture,
            repairDescription: that.formData.model.wechatMeterRepair.repairDescription,
            // 预约时间
            dealTime: that.formData.model.ticketsDeadline,
            // 是否解决
            solveStatus: that.formData.model.wechatMeterRepair.isSolve,
            // 处理人
            handleUserName: that.formData.model.wechatMeterRepair.handleUserName,
            handleUserRealName: that.formData.model.wechatMeterRepair.handleUserRealName,
            handleUserPhone: that.formData.model.wechatMeterRepair.handleUserPhone,
            handleUserDescription: that.formData.model.wechatMeterRepair.handleUserDescription,
            handleUserTime: that.formData.model.wechatMeterRepair.handleUserTime,
            resolvedPicture: that.formData.model.resolvedPicture,

            // fixPhone: that.formData.model.wechatMeterRepair.fixPhone,
            // fixDescription: that.formData.model.wechatMeterRepair.fixDescription,
            // fixPicture: that.formData.model.wechatMeterRepair.fixPicture,
            userId: that.formData.model.wechatMeterRepair.userId,
            userName: that.formData.model.wechatMeterRepair.userName,
            userIdNumber: that.formData.model.wechatMeterRepair.userIdNumber,
            mtName: that.formData.model.wechatMeterRepair.mtName,
            userPhone: that.formData.model.wechatMeterRepair.userPhone,
            meterId: that.formData.model.wechatMeterRepair.meterId,
            ifNeedChangeMeter: 0,
          })
          // 判断是否是系统用户
          if (that.formData.model.wechatMeterRepair && that.formData.model.wechatMeterRepair.userId) {
            // 系统用户
            this.$set(that.formData.model, 'repairCreateOrderUserType', 1)

            // 获取用户信息
            getAction(this.url.list, { userId: that.formData.model.user.userId }).then(res => {
              if (res.success) {
                this.$set(that.formData, 'userInfo', res.result.records[0] || {})
              }
            })
            let meterId = ''
            // 如果换表体里面 记录的有 旧表ID 则 查询表信息
            if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.oldMeterId) {
              meterId = that.formData.model.ticketsChangeMeter.oldMeterId
              // 获取旧表信息
              getAction(this.url.newMeterInfo, { meterId: meterId }).then(res => {
                if (res.success) {
                  this.$set(that.formData, 'oldMeter', res.result.records[0] || {})
                  that.setOldMeterNum()
                }
                that.getOldMeterInfo()
              })
            } else {
              // 换表体 没有旧表ID，则查询用户表信息
              getAction(this.url.list, { userId: that.formData.model.wechatMeterRepair.userId }).then(res => {
                if (res.success) {
                  this.$set(that.formData, 'oldMeter', { ...res.result.records[0] })
                  that.setOldMeterNum()
                  // 旧表机械读数 计算 剩余金额
                  // this.meterOldMachineSumFlowInput()
                }
                that.getOldMeterInfo()
              })
            }

            // 是否换表
            if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.newMeterId) {
              this.$set(that.formData.model, 'ifNeedChangeMeter', 1)
              // 换表
              if (that.formData.model.ticketsChangeMeter.changingMeterReason != null) {
                // 将后端返回的最后一层值转换为完整路径
                const fullPath = that.findCascaderPath(that.formData.model.ticketsChangeMeter.changingMeterReason)
                that.changingMeterReason = fullPath
              }
              // 新表数据
              if (that.formData.model.ticketsChangeMeter.newMeterId) {
                let params = {
                  meterId: that.formData.model.ticketsChangeMeter.newMeterId,
                }
                getAction(this.url.newMeterInfo, params).then(res => {
                  if (res.success) {
                    let selectedMeter = res.result.records[0]
                    that.formData.newMeter = res.result.records[0]
                    // 新表编号 新表口径 新表厂商 新表开始计费读数
                    this.$set(that.formData.newMeter, 'newMeterId', selectedMeter.meterId)
                    this.$set(that.formData.newMeter, 'newMtCaliber', selectedMeter.mtCaliber)
                    this.$set(that.formData.newMeter, 'newMtName', selectedMeter.mtName)
                    this.$set(
                      that.formData.newMeter,
                      'meterStartNum',
                      that.formData.model.ticketsChangeMeter.meterStartNum
                    )
                    // 是否收费
                    if (that.formData.model.infoPicture) {
                      this.$set(that.formData.model, 'payOrNot', '收费')
                    } else {
                      this.$set(that.formData.model, 'payOrNot', '不收费')
                    }
                  }
                })
              }
            } else {
              // 不需要换表
              this.$set(that.model, 'ifNeedChangeMeter', 0)
            }
          } else {
            // 非系统用户
            this.$set(that.formData.model, 'repairCreateOrderUserType', 0)
          }
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          let message = ''

          let params = {}
          if (this.optionType == '处理') {
            httpurl += this.url.pass
            method = 'post'
            message = this.$t('处理成功')
            // 报修

            params = {
              dataId: that.formData.model.id,
              createTicketDTO: {
                repairPicture: that.formData.model.repairPicture,
                resolvedPicture: that.formData.model.resolvedPicture,
                infoPicture: that.formData.model.infoPicture,

                ticketsRepairReq: {
                  id: that.formData.model.bzId ? that.formData.model.bzId : '',
                  repairName: that.formData.model.repairName,
                  repairPhone: that.formData.model.repairPhone,
                  repairAddress: that.formData.model.repairAddress,
                  repairTime: that.formData.model.repairTime,
                  repairPicture: that.formData.model.repairPicture,
                  repairDescription: that.formData.model.repairDescription,

                  solveStatus: 1,
                  // fixPhone: that.formData.model.fixPhone,
                  // fixDescription: that.formData.model.fixDescription,
                  // fixPicture: that.formData.model.fixPicture,
                  handleUserName: that.formData.model.handleUserName,
                  handleUserRealName: that.formData.model.handleUserRealName,
                  handleUserPhone: that.formData.model.handleUserPhone,
                  handleUserDescription: that.formData.model.handleUserDescription,
                  handleUserTime: that.formData.model.handleUserTime,
                  resolvedPicture: that.resolvedPicture, // 处理照片
                  userId: that.formData.model.userId,
                  userName: that.formData.model.userName,
                  userIdNumber: that.formData.model.userIdNumber,
                  mtName: that.formData.model.mtName,
                  userPhone: that.formData.model.userPhone,
                  ifNeedChangeMeter: that.formData.model.ifNeedChangeMeter, // 是否换表
                  /*
                        meterId: that.formData.model.meterId, // 旧表ID
                        repairCreateOrderUserType: that.repairCreateOrderUserType, // 用户类型
                        ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
                        whetherSettlementOldTable: that.model.whetherSettlementOldTable,// 是否以旧表机械读数结算
                        meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                        meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                        oldPicture: that.model.oldPicture, // 旧表照片
                        newMeterId:  that.model.newMeterId, // 新表ID
                        newPicture: that.model.newPicture, // 新表照片
                        meterStartNum: that.model.meterStartNum, // 新表开始计费读数
                        payOrNot: that.model.payOrNot, // 是否收费
                        resolvedPicture: that.model.resolvedPicture, // 支付凭证
                        repairRemark: that.model.repairRemark, // 最后的备注
                        */
                },
                ticketsChangeMeterReq: {
                  oldMeterBalances: that.formData.oldMeter.oldMeterBalances,
                  changingMeterReason: that.formData.model.changingMeterReason,
                  changingMeterReasonDetail: that.formData.model.changingMeterReasonDetail,
                  userAccountNum: that.formData.model.userAccountNum,
                  meterTotalUse: '',
                  oldMeterStartNum: that.formData.oldMeter.oldMeterStartNum,
                  oldUserCalNum: that.formData.oldMeter.oldUserCalNum,
                  meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterOldSumFlowAfterChange: that.formData.oldMeter.meterOldSumFlowAfterChange,
                  userKeyId: that.formData.model.userKeyId,
                  userId: that.formData.model.userId,
                  meterOldMachineSumFlow: that.formData.oldMeter.meterOldMachineSumFlow, // 旧表机械读数
                  whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  oldMeterId: that.formData.oldMeter.meterId, // 旧表ID
                  // oldPicture: that.formData.oldMeter.oldPicture, // 旧表照片
                  newMeterId: that.formData.newMeter.newMeterId, // 新表ID
                  // newPicture: that.model.newPicture, // 新表照片
                  meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                  payOrNot: that.formData.model.payOrNot, // 是否收费
                  resolvedPicture: that.formData.model.resolvedPicture, // 支付凭证
                  repairRemark: that.formData.model.repairRemark, // 最后的备注
                },
              },
              comment: that.formData.model.repairRemark,
            }
            /*
                debugger
                // 报修
                this.$set(params,'dataId',that.formData.model.id);
  
                this.$set(params,'ticketsFrom',that.formData.model.ticketsFrom);
                this.$set(params,'ticketsState',that.formData.model.ticketsState);
                this.$set(params,'userKeyId',that.formData.model.userKeyId);
                this.$set(params,'userId',that.formData.model.userId);
                // this.$set(params,'ifNeedChangeMeter',that.formData.model.yesOrNotChangeMeter);// 是否换表
                // this.$set(params,'repairPicture',that.model.repairPicture);// 报修照片
                // this.$set(params,'resolvedPicture',that.model.resolvedPicture);// 处理照片
                this.$set(params,'infoPicture',that.formData.model.infoPicture);// 支付凭证
  
                params.ticketsRepairReq = {
                    id: params.bzId ? params.bzId : '',
                    repairName: params.repairName,
                    repairPhone: params.repairPhone,
                    repairAddress: params.repairAddress,
                    repairTime: params.repairTime,
                    repairPicture: params.repairPicture,
                    repairDescription: params.repairDescription,
  
                    solveStatus: 1,
                    // fixPhone: params.fixPhone,
                    // fixDescription: params.fixDescription,
                    // fixPicture: params.fixPicture,
                    handleUserName: params.handleUserName,
                    handleUserRealName: params.handleUserRealName,
                    handleUserPhone: params.handleUserPhone,
                    handleUserDescription: params.handleUserDescription,
                    handleUserTime: params.handleUserTime,
                    resolvedPicture: that.resolvedPicture, // 处理照片
                    userId: params.userId,
                    userName: params.userName,
                    userIdNumber: params.userIdNumber,
                    mtName: params.mtName,
                    userPhone: params.userPhone,
                    ifNeedChangeMeter: params.ifNeedChangeMeter, // 是否换表
  
                    meterId: params.meterId, // 旧表ID
                    repairCreateOrderUserType: that.repairCreateOrderUserType, // 用户类型
                    ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
                    whetherSettlementOldTable: that.model.whetherSettlementOldTable,// 是否以旧表机械读数结算
                    meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                    meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                    oldPicture: that.model.oldPicture, // 旧表照片
                    newMeterId:  that.model.newMeterId, // 新表ID
                    newPicture: that.model.newPicture, // 新表照片
                    meterStartNum: that.model.meterStartNum, // 新表开始计费读数
                    payOrNot: that.model.payOrNot, // 是否收费
                    resolvedPicture: that.model.resolvedPicture, // 支付凭证
                    repairRemark: that.model.repairRemark, // 最后的备注
                    
                };
  
  
                params.ticketsChangeMeterReq = {
                    oldMeterBalances : that.formData.oldMeter.oldMeterBalances,
                    changingMeterReason: params.changingMeterReason,
                    changingMeterReasonDetail: params.changingMeterReasonDetail,
                    userAccountNum: params.userAccountNum,
                    meterTotalUse: "",
                    oldMeterStartNum: that.formData.oldMeter.oldMeterStartNum,
                    oldUserCalNum: that.formData.oldMeter.oldUserCalNum,
                    meterStartNum: "", 
                    meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                    meterOldSumFlowAfterChange: that.formData.oldMeter.meterOldSumFlowAfterChange,
                    userKeyId: params.userKeyId,
                    userId: params.userId,
                    meterOldMachineSumFlow: that.formData.oldMeter.meterOldMachineSumFlow, // 旧表机械读数
                    whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                    oldMeterId: that.formData.oldMeter.meterId, // 旧表ID
                    // oldPicture: that.formData.oldMeter.oldPicture, // 旧表照片
                    newMeterId:  that.formData.newMeter.newMeterId, // 新表ID
                    // newPicture: that.model.newPicture, // 新表照片
                    meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                    payOrNot: that.formData.model.payOrNot, // 是否收费
                    resolvedPicture: that.formData.model.resolvedPicture, // 支付凭证
                    repairRemark: that.formData.model.repairRemark, // 最后的备注
                }
                console.log("当前this.model数据",that.formData.model);
                console.log("当前报修提交数据",params);
  */
          } else {
            // 审核
            httpurl += this.url.pass
            method = 'post'
            message = this.$t('处理成功')
            params = {
              dataId: that.formData.model.id,
              values: {
                dataId: that.formData.model.id,
              },
              comment: '',
            }
          }
          httpAction(httpurl, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok')
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
              that.confirmLoading = false
            })
            .finally(() => {
              that.confirmLoading = false
            })
        } else {
          this.$message.warning(this.$t('存在必填内容未填！'))
        }
      })
    },
    meterOldMachineSumFlowInput() {
      if (this.formData.oldMeter.whetherSettlementOldTable == 1) {
        let params = {
          meterOldMachineSumFlow: this.formData.oldMeter.meterOldMachineSumFlow,
          userId: this.formData.oldMeter.userId,
          meterIdOld: this.formData.oldMeter.meterId ? this.formData.oldMeter.meterId : this.formData.model.meterId,
          userKeyId: this.formData.oldMeter.id ? this.formData.oldMeter.id : this.formData.model.userKeyId,
        }
        httpAction(this.url.useOldMachineSumFlow, params, 'put').then(res => {
          if (res.success) {
            this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', res.result)
          }
        })
      }
    },
    // 选择新表
    selectNewMeter() {
      this.selectNewMeterModalVisible = true
    },
    handleMeterSelected(selectedMeter) {
      this.selectedMeter = selectedMeter
      // 新表编号
      this.formData.newMeter.newMeterId = selectedMeter.meterId
      // 新表口径
      this.formData.newMeter.newMtCaliber = selectedMeter.mtCaliber
      // 新表厂商 =
      this.formData.newMeter.newMtName = selectedMeter.mtName

      console.log('选中的表信息:', selectedMeter)
      // 这里可以处理选中的表信息，比如保存到父组件的数据中
    },
    getTagColor(value) {
      switch (value) {
        case 0:
          return 'red'
        case 1:
          return 'orange'
        case 2:
          return 'yellow'
        case 3:
          return 'blue'
        default:
          return 'default' // 你可以设置一个默认颜色
      }
    },
    // 根据最后一层值查找完整路径，并返回全路径的label（使用/拼接）
    findCascaderPath(leafValue) {
      const stack = [...this.options.map(item => ({ path: [item.label], node: item }))]

      while (stack.length) {
        const { path, node } = stack.pop()

        // 找到目标节点，返回路径
        if (String(node.value) === String(leafValue)) {
          return path.join(' / ') // 返回用"/"拼接的完整路径label
        }

        // 如果有子节点，继续查找
        if (node.children) {
          stack.push(
            ...node.children.map(child => ({
              path: [...path, child.label], // 使用label构建路径
              node: child,
            }))
          )
        }
      }

      return '' // 没找到返回空字符串
    },
    setOldMeterNum() {
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.whetherSettlementOldTable != null
      ) {
        // 是否旧表结算
        this.$set(
          this.formData.oldMeter,
          'whetherSettlementOldTable',
          this.formData.model.ticketsChangeMeter.whetherSettlementOldTable
        )
      } else {
        this.$set(this.formData.oldMeter, 'whetherSettlementOldTable', '')
      }
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.meterOldMachineSumFlow != null
      ) {
        // 旧表机械读数
        this.$set(
          this.formData.oldMeter,
          'meterOldMachineSumFlow',
          this.formData.model.ticketsChangeMeter.meterOldMachineSumFlow
        )
      } else {
        this.$set(this.formData.oldMeter, 'meterOldMachineSumFlow', '')
      }
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange != null
      ) {
        // 剩余金额
        this.$set(
          this.formData.oldMeter,
          'meterUserAccountNumAfterChange',
          this.formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange
        )
      } else {
        this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', '')
      }
    },
    getOldMeterInfo() {
      let that = this
      // 已解决 换表的工单 则取 记录值
      if (that.formData.model.ticketsChangeMeter) {
        // 表计费起始读数
        this.$set(that.formData.oldMeter, 'oldMeterStartNum', that.formData.model.ticketsChangeMeter.oldMeterStartNum)
        // 末次上报结算流量
        this.$set(that.formData.oldMeter, 'oldUserCalNum', that.formData.model.ticketsChangeMeter.oldUserCalNum)
        // 末次上报结算余额
        this.$set(that.formData.oldMeter, 'userAccountNum', that.formData.model.ticketsChangeMeter.userAccountNum)
        this.$set(that.formData.oldMeter, 'meterUpTime', that.formData.model.ticketsChangeMeter.meterUpTime)
      } else {
        // 否则取 实时值
        getAction(that.url.getMeterUserInfoByKeyId, { userKeyId: that.formData.oldMeter.id }).then(res => {
          if (res.success) {
            this.$set(that.formData.oldMeter, 'oldMeterStartNum', that.formData.oldMeter.userMeterStartNum)
            this.$set(that.formData.oldMeter, 'oldUserCalNum', res.result.userCalNum)
            this.$set(that.formData.oldMeter, 'userAccountNum', res.result.userAccountNum)
            this.$set(that.formData.oldMeter, 'meterUpTime', res.result.meterUpTime)
          }
        })
      }
    },
    viewSig() {
      this.visibleSig = true
    },
    handleSigCancel() {
      this.visibleSig = false
    },
    downloadSig() {
      this.downloadFile(this.formData.model.ticketsChangeMeter.electronicSignature, this.$t('签名'))
    },
    downloadFile(url, name) {
      console.log('url==', url)
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
    handleCancel1() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  },
}
</script>
<style lang="less" scoped>
.box-sig {
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-sig {
    visibility: hidden;
    position: absolute;
    width: 180px;
    height: 80px;
    top: 10px;
    left: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;

    .icon-sig {
      color: rgba(255, 255, 255, 0.85);
      font-size: 16px;
    }
  }
  .mask-show {
    visibility: visible;
    transition: all 0.3s;
  }
}
</style>
